var _rect, _text, _text2, _text3, _g, _rect2, _text4, _g2, _g3, _text5, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase5Fig1ChainOfDefense(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 528",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 528,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "What stands between a local edit and a live production deploy")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Machine layers run on every change. The named human gates sit above the line and never move")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 126,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#7C3AED",
    fontWeight: 600
  }, "HUMAN GATES, NAMED AND FIXED")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontSize: 11.5,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 142,
    width: 196,
    height: 52,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 166
  }, "the merge that"), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 182
  }, "puts work live"), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 142,
    width: 196,
    height: 52,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 398,
    y: 166
  }, "any write to"), /*#__PURE__*/React.createElement("text", {
    x: 398,
    y: 182
  }, "production data"), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 142,
    width: 196,
    height: 52,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 638,
    y: 166
  }, "approving sustained"), /*#__PURE__*/React.createElement("text", {
    x: 638,
    y: 182
  }, "agent spend"), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 142,
    width: 196,
    height: 52,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 878,
    y: 166
  }, "locking an"), /*#__PURE__*/React.createElement("text", {
    x: 878,
    y: 182
  }, "architecture decision"), /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 142,
    width: 200,
    height: 52,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 1120,
    y: 166
  }, "money and legal"), /*#__PURE__*/React.createElement("text", {
    x: 1120,
    y: 182
  }, "ratification"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 270,
    width: 1160,
    height: 86,
    rx: 12,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 256,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#16A34A",
    fontWeight: 600
  }, "MACHINE LAYERS, RUN ON EVERY CHANGE")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontSize: 11.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: 304
  }, "worktree"), /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: 320
  }, "priming"), /*#__PURE__*/React.createElement("line", {
    x1: 188,
    y1: 286,
    x2: 188,
    y2: 340,
    stroke: "#D4DDD6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 252,
    y: 304
  }, "agents author"), /*#__PURE__*/React.createElement("text", {
    x: 252,
    y: 320
  }, "as data"), /*#__PURE__*/React.createElement("line", {
    x1: 316,
    y1: 286,
    x2: 316,
    y2: 340,
    stroke: "#D4DDD6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 304
  }, "local gate,"), /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 320
  }, "no credentials"), /*#__PURE__*/React.createElement("line", {
    x1: 448,
    y1: 286,
    x2: 448,
    y2: 340,
    stroke: "#D4DDD6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 304
  }, "two stop"), /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 320
  }, "hooks"), /*#__PURE__*/React.createElement("line", {
    x1: 572,
    y1: 286,
    x2: 572,
    y2: 340,
    stroke: "#D4DDD6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 634,
    y: 304
  }, "surgical"), /*#__PURE__*/React.createElement("text", {
    x: 634,
    y: 320
  }, "commits"), /*#__PURE__*/React.createElement("line", {
    x1: 696,
    y1: 286,
    x2: 696,
    y2: 340,
    stroke: "#D4DDD6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 304
  }, "required"), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 320
  }, "CI checks"), /*#__PURE__*/React.createElement("line", {
    x1: 816,
    y1: 286,
    x2: 816,
    y2: 340,
    stroke: "#D4DDD6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 878,
    y: 304
  }, "merge only"), /*#__PURE__*/React.createElement("text", {
    x: 878,
    y: 320
  }, "on green"), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 286,
    x2: 940,
    y2: 340,
    stroke: "#D4DDD6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1002,
    y: 304
  }, "schema-first"), /*#__PURE__*/React.createElement("text", {
    x: 1002,
    y: 320
  }, "deploy"), /*#__PURE__*/React.createElement("line", {
    x1: 1064,
    y1: 286,
    x2: 1064,
    y2: 340,
    stroke: "#D4DDD6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1142,
    y: 304
  }, "deploy verified,"), /*#__PURE__*/React.createElement("text", {
    x: 1142,
    y: 320
  }, "then audited"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7C3AED",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 158,
    y1: 194,
    x2: 158,
    y2: 270
  }), /*#__PURE__*/React.createElement("line", {
    x1: 398,
    y1: 194,
    x2: 398,
    y2: 270
  }), /*#__PURE__*/React.createElement("line", {
    x1: 638,
    y1: 194,
    x2: 638,
    y2: 270
  }), /*#__PURE__*/React.createElement("line", {
    x1: 878,
    y1: 194,
    x2: 878,
    y2: 270
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 194,
    x2: 1120,
    y2: 270
  }))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 404,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#6B7F74",
    fontWeight: 600
  }, "FOUR OF THE BIRTH INCIDENTS")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 432
  }, "A shared directory had its branch switched out from under an active session, so worktrees are primed per line of work."), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 454
  }, "A deploy served new code against an unmigrated schema, so the schema now applies before the code does."), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 476
  }, "A green suite passed a defect the reference itself carried, so an independent audit sits above the gate."), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 498
  }, "A secret-gated endpoint would have answered without its secret, so the code fails closed rather than trusting configuration."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase5Fig1ChainOfDefense);
export default __webpack_public_path__ + "static/media/case5-fig1-chain-of-defense.bf903fc41fdeb7a47ad91051dd886d44.svg";
export { ForwardRef as ReactComponent };